export const crossBrowserExitFullscreen = () => {
    if (document.exitFullscreen) {
        return document.exitFullscreen();
    }

    if (document.webkitExitFullscreen) {
        return document.webkitExitFullscreen();
    }
};

export const getCrossBrowserFullscreenElement = () => {
    return document.fullscreenElement || document.webkitCurrentFullScreenElement || null;
};

export const getCrossBrowserFullscreenEnabled = () => {
    return document.fullscreenEnabled || document.webkitFullscreenEnabled || false;
};
